<template>
  <div>
    <div class="header">
      <date-filter @onDateChanged="onDateChanged" />
      <vs-row
        v-if="tables && Array.isArray(tables) && tables.length > 0"
        class="tables-wrapper"
      >
        <vs-col vs-justify="center" vs-align="center" vs-w="12" class="p-0">
          <h6 class="mb-3">لیست شماره میزها</h6>
          <div style="display: flex; gap: 8px">
            <vs-select
              v-model="selectedTable"
              width="100%"
              @input="handleSelectedTable"
            >
              <vs-select-item
                v-for="(table, index) in tables"
                :value="table"
                :text="`${table.title}`"
                :key="index"
                icon="arrow_downward"
              />
            </vs-select>
            <vs-button
              v-if="selectedTable"
              style="padding: 0; min-width: 70px"
              size="small"
              color="danger"
              @click="resetTables"
              >حذف فیلتر</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </div>

    <div class="tabs-wrapper">
      <vs-tabs v-if="showTabs" alignment="fixed" v-model="defaultTab">
        <vs-tab label="سفارشات جدید" @click="handleClickTab(0)">
          <pagination-table
            ref="unlimitedList"
            title="سفارشات جدید"
            :tableHeaders="[
              'نوع سفارش',
              'نام و نام خانوادگی',
              'مبلغ فاکتور',
              'وضعیت پرداخت',
              'آخرین بروزرسانی فاکتور',
              'وضعیت',
            ]"
            :fetchData="fetchPendingOrdersPage"
            @onClickItem="onClickOrder"
          >
            <template v-slot:default="props">
              <td>
                <div class="flex flex-col">
                  {{ getOrderType(props.item.type) }}
                  <p v-if="props.item.type === 'indoor'">
                    {{ getOrderTable(props.item) }}
                  </p>
                </div>
              </td>
              <td>
                <div class="flex flex-col">
                  <P>
                    {{
                      props.item.user && props.item.user.name
                        ? props.item.user.name
                        : "کاربر تاپ منو"
                    }}
                  </P>
                  <P>
                    {{ props.item.user.phone }}
                  </P>
                </div>
              </td>
              <td>{{ props.item.price.toString().numberFormat() }} ریال</td>
              <td>
                {{ getPaymentType(props.item.paymentType) }}
              </td>
              <td>
                {{ props.item.created_at }}
              </td>
              <td>
                <div
                  class="status-wrapper"
                  :style="{
                    backgroundColor: getStatusColor(props.item.status),
                  }"
                >
                  {{ getStatus(props.item.status) }}
                </div>
              </td>
            </template>
          </pagination-table>
        </vs-tab>
        <vs-tab label="سفارشات بررسی شده" @click="handleClickTab(1)">
          <pagination-table
            ref="unlimitedList"
            title="سفارشات بررسی شده"
            :tableHeaders="[
              'نوع سفارش',
              'نام و نام خانوادگی',
              'مبلغ فاکتور',
              'وضعیت پرداخت',
              'آخرین بروزرسانی فاکتور',
              'وضعیت',
            ]"
            :fetchData="fetchDoneOrdersPage"
            @onClickItem="onClickOrder"
          >
            <template v-slot:default="props">
              <td>
                <div class="flex flex-col">
                  {{ getOrderType(props.item.type) }}
                  <p v-if="props.item.type === 'indoor'">
                    {{ getOrderTable(props.item) }}
                  </p>
                </div>
              </td>
              <td>
                <div class="flex flex-col">
                  <P>
                    {{
                      props.item.user && props.item.user.name
                        ? props.item.user.name
                        : "کاربر تاپ منو"
                    }}
                  </P>
                  <P>
                    {{ props.item.user.phone }}
                  </P>
                </div>
              </td>
              <td>{{ props.item.price.toString().numberFormat() }} ریال</td>
              <td>
                {{ getPaymentType(props.item.paymentType) }}
              </td>
              <td>
                {{ props.item.created_at }}
              </td>
              <td>
                <div
                  class="status-wrapper"
                  :style="{
                    backgroundColor: getStatusColor(props.item.status),
                  }"
                >
                  {{ getStatus(props.item.status) }}
                </div>
              </td>
            </template>
          </pagination-table>
        </vs-tab>
        <vs-tab label="در انتظار پرداخت" @click="handleClickTab(2)">
          <pagination-table
            ref="unlimitedList"
            title="سفارشات در انتظار پرداخت"
            :tableHeaders="[
              'نوع سفارش',
              'نام و نام خانوادگی',
              'مبلغ فاکتور',
              'وضعیت پرداخت',
              'آخرین بروزرسانی فاکتور',
              'وضعیت',
            ]"
            :fetchData="fetchPaymentRequiredOrdersPage"
            @onClickItem="onClickOrder"
          >
            <template v-slot:default="props">
              <td>
                <div class="flex flex-col">
                  {{ getOrderType(props.item.type) }}
                  <p v-if="props.item.type === 'indoor'">
                    {{ getOrderTable(props.item) }}
                  </p>
                </div>
              </td>
              <td>
                <div class="flex flex-col">
                  <P>
                    {{
                      props.item.user && props.item.user.name
                        ? props.item.user.name
                        : "کاربر تاپ منو"
                    }}
                  </P>
                  <P>
                    {{ props.item.user.phone }}
                  </P>
                </div>
              </td>
              <td>{{ props.item.price.toString().numberFormat() }} ریال</td>
              <td>
                {{ getPaymentType(props.item.paymentType) }}
              </td>
              <td>
                {{ props.item.created_at }}
              </td>
              <td>
                <div
                  class="status-wrapper"
                  :style="{
                    backgroundColor: getStatusColor(props.item.status),
                  }"
                >
                  {{ getStatus(props.item.status) }}
                </div>
              </td>
            </template>
          </pagination-table>
        </vs-tab>
      </vs-tabs>
    </div>
    <vs-button
      v-if="showUpdateButton"
      @click="update()"
      class="refresh-list"
      color="success"
      type="gradient"
      icon-pack="feather"
      icon="icon-refresh-ccw"
      >بروزرسانی لیست</vs-button
    >
    <reports-preview
      ref="reportsPreview"
      v-if="reportsVisible"
      :date="currentDate"
      :receiptCount="receiptCount"
      :tableId="selectedTable && selectedTable.id"
      @resetTables="resetTables"
    />

    <vs-popup :title="popupTitle" :active.sync="selectedOrder">
      <order
        v-if="selectedOrder"
        :order="selectedOrder"
        :index="selectedIndex"
        @refreshList="refreshList"
      ></order>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Order from "./../../components/order/Order.vue";
import orderApiService from "../../services/api/OrderApiService";
import DateFilter from "../../components/DateFilter.vue";
import ReportsPreview from "./ReportsPreview.vue";
import providerApiService from "../../services/api/ProviderApiService";
import PaginationTable from "../../components/pagination-table/PaginationTable.vue";
import { getOrderStatus } from "../../helpers/Functions";

export default {
  name: "Orders.vue",
  data() {
    return {
      showTabs: true,
      showUpdateButton: false,
      currentDate: null,
      reportsVisible: false,
      receiptCount: 0,
      defaultTab: 0,
      tables: null,
      selectedTable: null,
      timeout: null,
      selectedOrder: null,
    };
  },
  components: {
    Order,
    DateFilter,
    ReportsPreview,
    PaginationTable,
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
    popupTitle() {
      if (this.selectedOrder) {
        return "سفارش " + this.selectedOrder.serial;
      }

      return "سفارش جدید";
    },
  },
  mounted() {
    window.addEventListener("addOrder", this.onNewOrder);
    this.getDefaultTab();
    this.getProviderTables();
  },
  destroyed() {
    window.removeEventListener("addOrder", this.onNewOrder);
    this.timeout = null;
  },
  methods: {
    onNewOrder() {
      this.showUpdateButton = true;
    },
    refreshList() {
      if (this.$refs.unlimitedList) {
        this.$refs.unlimitedList.refresh();
        this.selectedOrder = null;
      }
    },
    onDateChanged(date) {
      this.currentDate = date;
      this.refreshList();
    },
    fetchPendingOrdersPage(page = 1) {
      this.reportsVisible = false;
      if (page === 1) this.showUpdateButton = false;
      return orderApiService.getOrders(
        this.currentProvider.id,
        page,
        ["pending"],
        this.currentDate,
        this.selectedTable?.id
      );
    },
    fetchDoneOrdersPage(page = 1) {
      this.reportsVisible = true;
      if (page === 1) this.showUpdateButton = false;
      return orderApiService
        .getOrders(
          this.currentProvider.id,
          page,
          ["approved", "denied"],
          this.currentDate,
          this.selectedTable?.id
        )
        .then((result) => {
          this.receiptCount = result.meta.total;
          return result;
        });
    },
    fetchPaymentRequiredOrdersPage(page = 1) {
      this.reportsVisible = false;
      if (page === 1) this.showUpdateButton = false;
      return orderApiService.getOrders(
        this.currentProvider.id,
        page,
        ["payment_required"],
        this.currentDate
      );
    },
    update() {
      this.showUpdateButton = this.showTabs = false;
      setTimeout(() => {
        this.showTabs = true;
      }, 10);
    },
    handleClickTab(value) {
      localStorage.setItem("orders_default_tab", value);
    },
    getDefaultTab() {
      const tab = localStorage.getItem("orders_default_tab");
      if (tab) {
        setTimeout(() => {
          this.defaultTab = +tab;
        }, 150);
      }
    },
    getProviderTables() {
      providerApiService
        .getProviderTablesList(this.currentProvider.id)
        .then((result) => {
          this.tables = result.data;
        });
    },
    handleSelectedTable(table) {
      this.selectedTable = table;
      this.refreshList();
    },
    resetTables() {
      this.selectedTable = null;
      this.refreshList();
    },
    getStatus(value) {
      return getOrderStatus(value);
    },
    getStatusColor(orderStatus) {
      const map = {
        approved: {
          color: "#28C76F",
        },
        pending: {
          color: "#FF9F43",
        },
        payment_required: {
          color: "#FF9F43",
        },
        canceled: {
          color: "#EA5455",
        },
        denied: {
          color: "#EA5455",
        },
        unsuccessful: {
          color: "#EA5455",
        },
      };
      const { color } = map[orderStatus];
      return color;
    },
    getPaymentType(paymentType) {
      if (paymentType === "offline") {
        return "پرداخت در محل";
      }

      return "آنلاین";
    },
    getOrderType(orderType) {
      if (orderType === "indoor") {
        return "داخل سالن";
      }
      if (orderType === "outdoor") {
        return "ارسالی";
      }

      return "تحویل در محل";
    },
    getOrderTable(order) {
      return "میز " + (order.table?.title || order.userDetails.destination);
    },
    onClickOrder(order) {
      this.selectedOrder = order;
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: flex-start;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}

.tabs-wrapper {
  min-height: calc(100vh - 130px);

  .status-wrapper {
    border-radius: 10px;
    padding: 8px 16px;
    width: fit-content;
    color: white;
  }
}

.refresh-list {
  position: sticky;
  bottom: 5%;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.12),
    0 7px 10px -5px rgba(0, 0, 0, 0.15);
}

.tables-wrapper {
  flex: 0.3;
  margin: 0;
  padding: 0;
  gap: 2px;

  @media screen and (max-width: 768px) {
    flex: 1;
    width: 100% !important;
  }
}

.delete-btns {
  position: sticky;
  bottom: 5%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 1000px) {
    bottom: 5%;
  }

  .delete-btn {
    margin: 4px 0;
    width: 200px;
    box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.12),
      0 7px 10px -5px rgba(0, 0, 0, 0.15);
  }
}
</style>
